// Filename - components/landing/Benefits.js

import React  from "react";
import { Container, Row, Col} from "react-bootstrap";


export default function Benefits (){


    return (
      <Container fluid className="p-5" >
         <Row className="mx-3 mt-3">
            <h3 className="display-4">Why Innovation? </h3>
            <p className="lead"> Leading with creativity and innovation has some surprising benefits</p>
         </Row>
         <Row className="mx-3">
            <Col className="col-12 col-md-4 text-center">
               <img className="img-fluid"
                     src="/images/hackingCreativity/Innovation-Outcome.png"
                     height="50%"
                     width = "50%"
                     alt="Outcome"
               />
               <h5 style={{color:'#c87137'}}>Outcome</h5>
               <p>
                  Be it profits or student learning, infusing creativity into your workflows leads to better outcomes. 
               </p>
            </Col>
            <Col className="col-12 col-md-4 text-center">
               <img className="img-fluid"
                     src="/images/hackingCreativity/Innovation-Engagement.png"
                     height="50%"
                     width = "50%"
                     alt="Engagement"
               />
               <h5 style={{color:'#c87137'}}>Engagement</h5>
               <p>
                  When individual ideas are allowed to flourish, employee and student engagement skyrocket. 
               </p>
            </Col>
            <Col className="col-12 col-md-4 text-center">
               <img className="img-fluid"
                     src="/images/hackingCreativity/Innovation-Inclusion.png"
                     height="50%"
                     width = "50%"
                     alt="Inclusion"
               />
               <h5 style={{color:'#c87137'}}>Inclusion</h5>
               <p>
                   An environment that respects different ideas, leads to an inclusive environment. 
               </p>
            </Col>
         </Row>
         
         

      </Container>
    )

}
